import React, { Component } from 'react'
import { Rectangle, Circle } from 'react-shapes';
import Typography from '@material-ui/core/Typography';
import setting from '../../config/setting'

class ThresholdUI extends Component {
    render() {
        let thresdholdKey = this.props.kri.risk_name.split(' ')[0].slice(0, -1)
                            + this.props.kri.kri_id.split(' ').join('')
        let lowerB = (this.props.threshold.lowkrithreshold)[thresdholdKey]
        let higherB = (this.props.threshold.highkrithreshold)[thresdholdKey]
        let value = this.props.value

        let markerPadding = 0
        if (value < lowerB) {
            markerPadding = 100 * value / lowerB
        } else if (value < higherB) {
            markerPadding = markerPadding + 100
            markerPadding = markerPadding + 100*(value - lowerB)/(higherB-lowerB)
        } else {
            markerPadding = markerPadding + 200
            markerPadding = markerPadding + Math.min((value - higherB), 100)
        }
        markerPadding = markerPadding - 10

        return (
            <div style={{ position: 'relative'}}>
                <div style={{position:'absolute', top:'100px', left:'8vw'}}>
                    <Rectangle width={100} height={15} fill={{ color: setting.COLOR.GREEN }} strokeWidth={0} />
                    <Rectangle width={100} height={15} fill={{ color: setting.COLOR.AMBER }} strokeWidth={0} />
                    <Rectangle width={100} height={15} fill={{ color: setting.COLOR.RED }} strokeWidth={0} />
                    <Typography style={{ position:'relative', fontSize: '15px', transform:'translateX(-50px)'}} >{lowerB}</Typography>
                    <Typography style={{ position:'relative', fontSize: '15px', transform:'translateX(50px) translateY(-21px)'}} >{higherB}</Typography>
                </div>
                <div style={{position: 'absolute', top: '96px', left:'calc(8vw + ' + markerPadding + 'px)'}}>
                    <Typography style={{position:'absolute', fontSize:'15px', top:'-24px'}}>{this.props.value}</Typography>
                    <Circle r={11} fill={{color:setting.COLOR.LIGHT_BLUE}} stroke={{color:'#000000'}} strokeWidth={1} />
                </div>
            </div>
        )
    }
}
export default ThresholdUI


// WEBPACK FOOTER //
// ./src/components/SharedComponents/ThresholdUI.js